import styled from '@emotion/styled';

import COLORS from '../../styles/emotion/colors3';
import { FONT, MEDIA_QUERY, SPACING } from '../../styles/emotion';

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 280px;

  ${MEDIA_QUERY.DESKTOP_XL} {
    width: 350px;
  }

  ${MEDIA_QUERY.TABLET} {
    width: 182px;
  }

  ${MEDIA_QUERY.MOBILE_XS} {
    width: 237px;
  }
`;

export const LinkWrapper = styled.div`
  margin-top: ${SPACING.S24};
  font-size: ${FONT.FONT_SIZE_SMALLER};

  ${MEDIA_QUERY.MOBILE_XS} {
    margin-top: ${SPACING.S16};
  }
`;

export const Prehed = styled.p`
  color: ${COLORS.BLACK_050};
  margin-bottom: 0;

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    font-size: ${FONT.FONT_SIZE_SMALLER};
  }
`;

export const Hed = styled.h4`
  ${FONT.textSizeCompact(FONT.SIZE.REGULAR)}
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  color: ${COLORS.WHITE_100};
  margin: 0;
  margin-bottom: ${SPACING.S16} !important;
  letter-spacing: normal;

  ${MEDIA_QUERY.TABLET} {p
    ${FONT.textSizeCompact(FONT.SIZE.SMALL)}
    margin-bottom: ${SPACING.XS} !important;
  }

  ${MEDIA_QUERY.MOBILE} {
    ${FONT.textSizeCompact(FONT.SIZE.SMALL)}
    margin-bottom: ${SPACING.XS};
    line-height: normal;
  }
`;

export const Dek = styled.p`
  color: ${COLORS.BLACK_075};
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 182px;
  border-radius: 16px;
  margin-bottom: ${SPACING.S24};

  ${MEDIA_QUERY.DESKTOP_XL} {
    height: 350px;
  }

  ${MEDIA_QUERY.DESKTOP_LG} {
    height: 280px;
  }

  ${MEDIA_QUERY.TABLET} {
    margin-bottom: ${SPACING.S24};
  }

  ${MEDIA_QUERY.MOBILE_XS} {
    height: 237px;
    margin-bottom: ${SPACING.S16};
  }

  ${MEDIA_QUERY.MOBILE} {
    width: auto;
    max-width: 100%;
  }
`;
